import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function SolidPlaneIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M20.8 12.6c0-.4-.2-.7-.6-.9l-6.1-3.1V4c0-1.1-.9-2-2.1-2-1.2 0-2.1.9-2.1 2.1v4.6l-6.1 3.1c-.3.2-.6.5-.6.9V14c0 .6.4 1 1 1 .1 0 .2 0 .4-.1l5.3-2V18c0 .4-.3.8-.7.9l-1.1.4c-.4.1-.7.5-.7.9v.8c0 .6.4 1 1 1h7.2c.6 0 1-.4 1-1v-.8c0-.4-.3-.8-.7-.9l-1.1-.4c-.4-.1-.7-.5-.7-.9v-5.1l5.3 2c.5.2 1.1-.1 1.3-.6 0-.1.1-.2.1-.4v-1.3Z"/>
  </SvgIcon>
}

export default SolidPlaneIcon
